import { ModalStackState, ModalStackItem } from './types';
import { reduxKey } from './constants';

export function getCurrentModal(state: ModalStackState) {
  const stack = state[reduxKey];

  if (!stack || !stack.length) {
    return;
  }

  return stack[stack.length - 1] as ModalStackItem;
}

export function getModals(state: ModalStackState) {
  const stack = state[reduxKey];
  if (!stack) {
    return [];
  }

  return stack;
}
